import int01 from "./Introduccion/Intro-01.mp3";
import int02 from "./Introduccion/Intro-02.mp3";
import int03 from "./Introduccion/Intro-03.mp3";

import sub1_act1_a01 from "./Subtema-1/T5-Sub 1-Act 1-A01.mp3";
import sub1_act1_a02 from "./Subtema-1/T5-Sub 1-Act 1-A02.mp3";
import sub1_act1_a03 from "./Subtema-1/T5-Sub 1-Act 1-A03.mp3";
import sub1_act1_a04 from "./Subtema-1/T5-Sub 1-Act 1-A04.mp3";
import sub1_act1_a05 from "./Subtema-1/T5-Sub 1-Act 1-A05.mp3";
import sub1_act1_a06 from "./Subtema-1/T5-Sub 1-Act 1-A06.mp3";
import sub1_act1_a07 from "./Subtema-1/T5-Sub 1-Act 1-A07.mp3";
import sub1_act1_a08 from "./Subtema-1/T5-Sub 1-Act 1-A08.mp3";
import sub1_act1_a09 from "./Subtema-1/T5-Sub 1-Act 1-A09.mp3";
import sub1_act1_a10 from "./Subtema-1/T5-Sub 1-Act 1-A10.mp3";
import sub1_act1_a11 from "./Subtema-1/T5-Sub 1-Act 1-A11.mp3";
import sub1_act1_a12 from "./Subtema-1/T5-Sub 1-Act 1-A12.mp3";
import sub1_act1_a13 from "./Subtema-1/T5-Sub 1-Act 1-A13.mp3";
import sub1_act1_a14 from "./Subtema-1/T5-Sub 1-Act 1-A14.mp3";
import sub1_act1_a15 from "./Subtema-1/T5-Sub 1-Act 1-A15.mp3";
import sub1_act2_a01 from "./Subtema-1/T5-Sub 1-Act 2-A01.mp3";

import sub2_act1_a01 from "./Subtema-2/T5-Sub 2-Act 1-A01.mp3";
import sub2_act1_a02 from "./Subtema-2/T5-Sub 2-Act 1-A02.mp3";
import sub2_act1_a03 from "./Subtema-2/T5-Sub 2-Act 1-A03.mp3";
import sub2_act2_a01 from "./Subtema-2/T5-Sub 2-Act 2-A01.mp3";
import sub2_act2_a02 from "./Subtema-2/T5-Sub 2-Act 2-A02.mp3";
import sub2_act2_a03 from "./Subtema-2/T5-Sub 2-Act 2-A03.mp3";
import sub2_act2_a04 from "./Subtema-2/T5-Sub 2-Act 2-A04.mp3";
import sub2_act2_a05 from "./Subtema-2/T5-Sub 2-Act 2-A05.mp3";

import sub3_act1_a01 from "./Subtema-3/T5-Sub 3-Act 1-A01.mp3";
import sub3_act1_a02 from "./Subtema-3/T5-Sub 3-Act 1-A02.mp3";
import sub3_act2_a01 from "./Subtema-3/T5-Sub 3-Act 2-A01.mp3";
import sub3_act2_a02 from "./Subtema-3/T5-Sub 3-Act 2-A02.mp3";
import sub3_act2_a03 from "./Subtema-3/T5-Sub 3-Act 2-A03.mp3";
import sub3_act2_a04 from "./Subtema-3/T5-Sub 3-Act 2-A04.mp3";
import sub3_act2_a05 from "./Subtema-3/T5-Sub 3-Act 2-A05.mp3";
import sub3_act2_a06 from "./Subtema-3/T5-Sub 3-Act 2-A06.mp3";
import sub3_act2_a07 from "./Subtema-3/T5-Sub 3-Act 2-A07.mp3";
import sub3_act2_a08 from "./Subtema-3/T5-Sub 3-Act 2-A08.mp3";
import sub3_act2_a09 from "./Subtema-3/T5-Sub 3-Act 2-A09.mp3";
import sub3_act2_a10 from "./Subtema-3/T5-Sub 3-Act 2-A10.mp3";
import sub3_act2_a11 from "./Subtema-3/T5-Sub 3-Act 2-A11.mp3";
import sub3_act2_a12 from "./Subtema-3/T5-Sub 3-Act 2-A12.mp3";
import sub3_act2_a13 from "./Subtema-3/T5-Sub 3-Act 2-A13.mp3";
import sub3_act2_a14 from "./Subtema-3/T5-Sub 3-Act 2-A14.mp3";
import sub3_act2_a15 from "./Subtema-3/T5-Sub 3-Act 2-A15.mp3";
import sub3_act2_a16 from "./Subtema-3/T5-Sub 3-Act 2-A16.mp3";
import sub3_act3_a01 from "./Subtema-3/T5-Sub 3-Act 3-A01.mp3";
import sub3_act3_a02 from "./Subtema-3/T5-Sub 3-Act 3-A02.mp3";

import sub4_act1_a01 from "./Subtema-4/T5-Sub 4-Act 1-A01.mp3";
import sub4_act1_a02 from "./Subtema-4/T5-Sub 4-Act 1-A02.mp3";
import sub4_act1_a03 from "./Subtema-4/T5-Sub 4-Act 1-A03.mp3";
import sub4_act1_a04 from "./Subtema-4/T5-Sub 4-Act 1-A04.mp3";
import sub4_act1_a05 from "./Subtema-4/T5-Sub 4-Act 1-A05.mp3";
import sub4_act1_a06 from "./Subtema-4/T5-Sub 4-Act 1-A06.mp3";
import sub4_act1_a07 from "./Subtema-4/T5-Sub 4-Act 1-A07.mp3";
import sub4_act1_a08 from "./Subtema-4/T5-Sub 4-Act 1-A08.mp3";
import sub4_act1_a09 from "./Subtema-4/T5-Sub 4-Act 1-A09.mp3";
import sub4_act1_a10 from "./Subtema-4/T5-Sub 4-Act 1-A10.mp3";
import sub4_act1_a11 from "./Subtema-4/T5-Sub 4-Act 1-A11.mp3";
import sub4_act1_a12 from "./Subtema-4/T5-Sub 4-Act 1-A12.mp3";
import sub4_act1_a13 from "./Subtema-4/T5-Sub 4-Act 1-A13.mp3";
import sub4_act1_a14 from "./Subtema-4/T5-Sub 4-Act 1-A14.mp3";
import sub4_act1_a15 from "./Subtema-4/T5-Sub 4-Act 1-A15.mp3";
import sub4_act1_a16 from "./Subtema-4/T5-Sub 4-Act 1-A16.mp3";
import sub4_act1_a17 from "./Subtema-4/T5-Sub 4-Act 1-A17.mp3";
import sub4_act1_a18 from "./Subtema-4/T5-Sub 4-Act 1-A18.mp3";
import sub4_act1_a19 from "./Subtema-4/T5-Sub 4-Act 1-A19.mp3";
import sub4_act1_a20 from "./Subtema-4/T5-Sub 4-Act 1-A20.mp3";
import sub4_act1_a21 from "./Subtema-4/T5-Sub 4-Act 1-A21.mp3";

export const T5_voices = {
	introduccion: {
		int01,
		int02,
		int03,
	},
	sub01: {
		sub1_act1_a01,
		sub1_act1_a02,
		sub1_act1_a03,
		sub1_act1_a04,
		sub1_act1_a05,
		sub1_act1_a06,
		sub1_act1_a07,
		sub1_act1_a08,
		sub1_act1_a09,
		sub1_act1_a10,
		sub1_act1_a11,
		sub1_act1_a12,
		sub1_act1_a13,
		sub1_act1_a14,
		sub1_act1_a15,
		sub1_act2_a01,
	},
	sub02: {
		sub2_act1_a01,
		sub2_act1_a02,
		sub2_act1_a03,
		sub2_act2_a01,
		sub2_act2_a02,
		sub2_act2_a03,
		sub2_act2_a04,
		sub2_act2_a05,
	},
	sub03: {
		sub3_act1_a01,
		sub3_act1_a02,
		sub3_act2_a01,
		sub3_act2_a02,
		sub3_act2_a03,
		sub3_act2_a04,
		sub3_act2_a05,
		sub3_act2_a06,
		sub3_act2_a07,
		sub3_act2_a08,
		sub3_act2_a09,
		sub3_act2_a10,
		sub3_act2_a11,
		sub3_act2_a12,
		sub3_act2_a13,
		sub3_act2_a14,
		sub3_act2_a15,
		sub3_act2_a16,
		sub3_act3_a01,
		sub3_act3_a02,
	},
	sub04: {
		sub4_act1_a01,
		sub4_act1_a02,
		sub4_act1_a03,
		sub4_act1_a04,
		sub4_act1_a05,
		sub4_act1_a06,
		sub4_act1_a07,
		sub4_act1_a08,
		sub4_act1_a09,
		sub4_act1_a10,
		sub4_act1_a11,
		sub4_act1_a12,
		sub4_act1_a13,
		sub4_act1_a14,
		sub4_act1_a15,
		sub4_act1_a16,
		sub4_act1_a17,
		sub4_act1_a18,
		sub4_act1_a19,
		sub4_act1_a20,
		sub4_act1_a21,
	},
};
